package data.models

import kotlinx.serialization.Serializable

@Serializable
data class RegistrationData(
    val email: String,
    val password: String,
)


